<template>
  <div class="binding-info">
    <h3 class="binding-title">蓝桥运单物通修改推送绑定</h3>
    <van-cell-group>
      <van-cell title="当前绑定手机号" :value="mobile"></van-cell>
      <van-cell title="企业ID" :value="companyId"></van-cell>
      <van-cell title="当前绑定公司" :value="companyName"></van-cell>
      <van-cell title="推送人" :value="pusherName"></van-cell>
    </van-cell-group>
    <!--<div class="btn">-->
    <!--<van-button type="danger" size="normal" @click="changeClick">修改</van-button>-->
    <!--</div>-->
  </div>
</template>

<script>
export default {
  name: "BindingInfo",
  data() {
    return {
      mobile: this.$route.params.mobile,
      companyName: "",
      pusherName: "",
      companyId: ""
    };
  },
  mounted() {
    let params = {
      params: this.$route.params.mobile
    };
    this.$axios.post("lanqiao/push/getMessageByMobile", params).then(res => {
      if (res.data.code === 200) {
        this.mobile = res.data.data.mobile;
        this.companyName = res.data.data.companyName;
        this.companyId = res.data.data.companyId;
        this.pusherName = res.data.data.pusherName;
      }
    });
  },
  methods: {
    changeClick() {}
  }
};
</script>

<style scoped lang="scss">
.binding-title {
  background-color: #fff;
  font-size: 0.45rem;
  text-align: center;
  padding: 0.425rem 0;
}

.btn {
  padding: 0 0.25rem;
  margin: 0.25rem 0;
  display: flex;
  justify-content: space-around;

  .van-button {
    flex: 1;
    margin: 0 0.25rem;
  }
}
</style>
